import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddOutsourceleadComponent } from './add-outsourcelead/add-outsourcelead.component';
import { AddComponent } from './add/add.component';
import { AllLeadsReportsComponent } from './all-leads-reports/all-leads-reports.component';
import { ListComponent } from './list/list.component';
import { OutsourceViewComponent } from './outsource-view/outsource-view.component';
import { ViewComponent } from './view/view.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { LeadActionComponent } from './lead-action/lead-action.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'training-leads', component: ListComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment','Training Moderator'] }
      },
      {
        path: 'outsource-leads', component: ListComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment','Sales'] }
      },
      {
        path: 'training-leads-reports', component: AllLeadsReportsComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment','Training Moderator'] }
      },
      {
        path: 'outsource-leads-reports', component: AllLeadsReportsComponent,
        canActivate: [PermissionGuard],
        data: { roles: ['admin','Managment','Sales','HR'] }
      },

      {
        path: 'add', component: AddComponent
      },
      {
        path: 'add-outsource-lead', component: AddOutsourceleadComponent
      },
      {
        path: 'outsource-lead-edit/:id', component: AddOutsourceleadComponent
      },
      {
        path: 'view/:id', component: ViewComponent
      },
      {
        path: 'edit/:id', component: AddComponent
      },
      {
        path: 'outsource-lead-view/:id', component: OutsourceViewComponent
      },
      {
        path:'lead-action',component:LeadActionComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadsNewRoutingModule { }
